import React, { useEffect } from 'react';
import { Result } from 'antd';
import { useAccess, useLocation } from '@umijs/max';
import { DEFAULT_ACCESS_URL_MAP, FROM_TO_LOGIN } from '@/constants/common';

const NoAccessPage: React.FC = () => {
  const location = useLocation();
  const access = useAccess();

  // NOTE 如果有权限则按照顺序跳转至指定页面
  useEffect(() => {

    // NOTE 如果不是从登录页面跳转过来的，则不进行以下无权限时的默认页面跳转。
    if (!sessionStorage.getItem(FROM_TO_LOGIN)) {
      return;
    }

    let accessList = Object.keys(DEFAULT_ACCESS_URL_MAP);
    accessList = accessList.filter((keyName) => access[keyName as keyof typeof access]);

    if (accessList.length === 0) {

      return;
    }

    const url = DEFAULT_ACCESS_URL_MAP[accessList[0] as keyof typeof DEFAULT_ACCESS_URL_MAP];
    window.location.replace(url);

  }, [location.pathname]);

  return (
    <Result
      // extra={<Button onClick={()=>history.push('/tickets/system')} type="primary">回到首页</Button>}
      status="403"
      subTitle="请联系管理员开通"
      title="暂无权限"
    />
  );
};

export default NoAccessPage;
